import { Link } from "react-router-dom";

interface ExpoLogoProps {
  to?: string;
  height?: number;
  className?: string;
}

export function ExpoLogo({ to = "/", height = 60, className = "" }: ExpoLogoProps) {
  return (
    <Link to={to} className={className}>
      <img src="/head-logo.png" alt="House & Condo Expo" style={{ height: `${height}px` }} />
    </Link>
  );
}
